import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full gap-2" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg leading-5 text-zinc-800 text-left"
}
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-row w-full items-center gap-2" }
const _hoisted_6 = { class: "flex flex-col w-full" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex flex-wrap gap-2 mt-3" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showTitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Expert Tags "))
        : _createCommentVNode("", true),
      _createVNode(_component_BaseLabel, {
        forAttr: "expertTags",
        text: "Add custom tags to your expert program so experts can further personalize and customize their expertise! Custom tags are used to showcase popular features, unique use cases, industry specific expertise, and more. These tags can then be used to filter experts in your booking system to find more relevant experts. Once you save new tags all your active experts will receive an email prompting them to update their profile.",
        class: "text-sm leading-5 mt-1 text-gray-500 text-left"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BaseInput, {
            id: "expertTags",
            modelValue: _ctx.newPopularProduct,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPopularProduct) = $event)),
            placeholder: "Enter expert tags",
            className: "px-3.5 py-2.5 w-full border border-gray-300 rounded-md text-sm font-normal leading-5 whitespace-nowrap",
            onKeydown: _withKeys(_withModifiers(_ctx.addPopularProduct, ["prevent"]), ["enter"])
          }, null, 8, ["modelValue", "onKeydown"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_BaseButton, {
            type: "button",
            text: "Add",
            class: "max-w-max border border-gray-300 rounded-full px-2.5 py-1",
            onClick: _ctx.addPopularProduct
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" + ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      (_ctx.addPopularProductError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "text-xs text-red-500 text-left" }, " Tag already present! ", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (product, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex items-center bg-gray-100 rounded-md px-3 py-1.5"
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(product), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (_ctx.removeProduct(index)),
              class: "ml-2 text-gray-500 hover:text-gray-700"
            }, " × ", 8, _hoisted_12)
          ]))
        }), 128))
      ])
    ])
  ]))
}